import { HttpService } from 'core/modules/network-service';
import { get, merge } from 'lodash';
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';

// get store
const store = getStore();

// local dependencies
import { getVisibleItems } from 'resolvers/getVisibleEntities';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc MemberPrescriptionDetail defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberPrescriptionDetailService } from 'services/memberPrescriptionDetail';
 *
 * // create service instance and send/cancel request
 * const memberPrescriptionDetailService = new MemberPrescriptionDetailService();
 * const result = await memberPrescriptionDetailService.fetchData( '<user-id>' ); // fetch data
 * memberPrescriptionDetailService.cancel(); // cancel an active request
 */
export class MemberPrescriptionDetailService extends HttpService {

    // fetch call control widget data
    async fetchData( { url = {}, data = {} } = {} ) {

        const callerType = get( store.getState()[ REDUCER.CALL_STATE ], 'callerType', null );

        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge( data,
                    {
                        context: {
                            callerType
                        }
                    }
                )
            } );

            // extract widgets from the response
            const visibility = get( response, 'body.component.visibility', {} );
            const widgets = get( response, 'body.component.structure.widgets', [] );
            const navActions = get( response, 'body.component.structure.navActions', [] );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    widgets: getVisibleItems( widgets, visibility ),
                    navActions: getVisibleItems( navActions, visibility ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }


    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
